/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Category_OtherInputs */

const en_us2_community_category_other = /** @type {(inputs: Community_Category_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const pt_br2_community_category_other = /** @type {(inputs: Community_Category_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outro`)
};

const es_419_community_category_other = /** @type {(inputs: Community_Category_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otro`)
};

const pt_pt2_community_category_other = /** @type {(inputs: Community_Category_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outro`)
};

const fr_fr2_community_category_other = /** @type {(inputs: Community_Category_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autre`)
};

const de_de2_community_category_other = /** @type {(inputs: Community_Category_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstiges`)
};

const it_it2_community_category_other = /** @type {(inputs: Community_Category_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altro`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Community_Category_OtherInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_category_other = /** @type {((inputs?: Community_Category_OtherInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Category_OtherInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_category_other(inputs)
	if (locale === "es-419") return es_419_community_category_other(inputs)
	if (locale === "pt-PT") return pt_pt2_community_category_other(inputs)
	if (locale === "fr-FR") return fr_fr2_community_category_other(inputs)
	if (locale === "de-DE") return de_de2_community_category_other(inputs)
	if (locale === "it-IT") return it_it2_community_category_other(inputs)
	return en_us2_community_category_other(inputs)
});
export { community_category_other as "community.category_other" }